import { myListsDetailsOptionsStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListDetailsPagination";
import { GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import { PaginationStyle } from "@insite/mobius/Pagination";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";


myListsDetailsOptionsStyles.paginationContainer = {
    css: css`
        margin: 0;
        > ${GridOffset} {
            margin: 0px;
            width: 100%;
        }
    `,
};

myListsDetailsOptionsStyles.paginationGridItem = {
    width: 12,
    css: css`
        justify-content: flex-end;
        padding: 0px;
        > ${PaginationStyle} {
            width: 100%;
            padding: 5px;
            background-color: ${getColor("secondary")};
            label {
                font-weight: normal !important;
                color: ${getColor("text.main")} !important;
                font-size: 14px !important;
            }
            select {
                font-size: 14px !important;
                height: 36px;
            }
        }
    `,
};